import Axios from 'axios';

// TODO: Extend API to support loading of multiple groepnamen at once

function getCodeType(groepnaam) {
  return Axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/v1/codetype/${groepnaam}`).then(
    ({ data }) => data
  );
}

export default {
  getCodeType
};
